import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ["./page-not-found.component.css"],
})
export class PageNotFoundComponent implements OnInit {
  isRefSPay: boolean = false;

  constructor(
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private router: Router) {
    if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.Ref) {
      this.isRefSPay = true;
      localStorage.setItem("NotFound", JSON.stringify({ IsRefSpay: true }));
    }
  }

  ngOnInit() {
    var data = localStorage.getItem("NotFound");
    if (data) {
      let info = JSON.parse(data);
      this.isRefSPay = info.IsRefSpay
    }
  }
}
